import { useEffect, useState } from 'react'
import { RenderFieldExtensionCtx } from 'datocms-plugin-sdk'
import { Canvas } from 'datocms-react-ui'
import Table from 'src/components/Table'
import { isEqual, get } from 'lodash'
import { initialCellValue } from 'src/components/Cell'
import { Table as TableType } from 'src/types'

const initialTableValue: TableType = {
  title: '',
  options: {
    mainColumn: 0,
    mainRow: 0,
  },
  data: [
    [initialCellValue(), initialCellValue()],
    [initialCellValue(), initialCellValue()],
  ],
}

type Props = {
  ctx: RenderFieldExtensionCtx
}

export default function FieldExtension({ ctx }: Props) {
  const rawValues = get(ctx.formValues, ctx.fieldPath) as string | null
  const parsedValues = rawValues === null ? null : JSON.parse(rawValues)

  const [value, setValue] = useState<TableType>(parsedValues ?? initialTableValue)

  useEffect(() => {
    if (!isEqual(parsedValues, value)) {
      ctx.setFieldValue(
        ctx.fieldPath,
        value === null ? null : JSON.stringify(value),
      )
    }
  }, [ctx, parsedValues, value])

  return (
    <Canvas ctx={ctx}>
      <Table ctx={ctx} value={value} onUpdate={(e) => setValue(e)} />
    </Canvas>
  )
}
